import styled from '@emotion/styled';
import {css} from '@emotion/react';
import {colors, sizes} from 'patient-ping-remedy/packages/theme';
import {contentStyles} from '@common/messages/MessageEditor.styles';
import {StandardTypography} from 'patient-ping-remedy/packages/typography';

export const Wrapper = styled.div((props: { own: boolean }) => css`
  display: flex;
  gap: ${sizes.xSmall};

  ${props.own && css`
    flex-direction: row-reverse;
    justify-content: end;
  `}
`);

export const AvatarWrapper = styled.div`
  padding: 8px 0;
`;

export const ContentWrapper = styled(StandardTypography)`
  word-break: break-word;
  max-width: 65%;
  padding-inline: ${sizes.small};
  background: ${colors.cream1};
  border: 1px solid ${colors.gray3};
  border-radius: 8px;
`;

export const Content = styled.div`
  padding-block: ${sizes.xxSmall};

  ${contentStyles}
`;

export const Attachment = styled.button`
  margin: 0 !important;
  cursor: pointer;
`;
